import type { RefObject } from 'react';
import _ from 'lodash';

import { useEventListener } from './useEventListener';

type EventType = 'mousedown' | 'mouseup' | 'touchstart' | 'touchend';

export function useOnClickOutside<T extends HTMLElement = HTMLElement>(
    ref: RefObject<T | null>,
    handler: (event: MouseEvent | TouchEvent) => void,
    eventType: EventType = 'mousedown',
): void {
    useEventListener(eventType, (event) => {
        const target = event.target as Node;

        if (!target) {
            return;
        }

        const isOutside = Array.isArray(ref)
            ? _.every(ref, (r) => r.current && !r.current.contains(target))
            : ref.current && !ref.current.contains(target);

        if (isOutside) {
            handler(event);
        }
    });
}
